/**
 * @Author: 仙道
 * @Date: 2022-08-27 13:24:33
 * @LastEditTime: 2022-08-27 15:03:12
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/utils/debounce.js
 **/
import Vue from 'vue'
Vue.directive('debounce', {
  inserted: function (el, binding) {
    let timer
    el.addEventListener('keyup', () => {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        binding.value()
      }, 500)
    })
  }
})
